<template>
  <div>
    <div>
      <div
        v-if="!successfullyCreatedAccount"
        class="majorTitle paddingNoneTop"
      >
        Create an Account
      </div>
      <div
        v-else
        class="majorTitle paddingNoneTop"
      >
        Account Created
      </div>
      <ApiResponse :context="'create_account'" />
      <div
        v-if="!successfullyCreatedAccount"
        class="textLeft"
      >
        <div
          v-if="showError"
          class="row"
        >
          <div class="twelve columns">
            <h3 style="color:red; text-align: center; margin-bottom: 32px;">
              Invalid format. Please use the Latin
              Alphabet.
            </h3>
          </div>
        </div>

        <!-- First name and Last name -->
        <div class="row">
          <div class="six columns">
            <!-- First Name -->
            <div class="tallInput">
              First Name <span class="colorGrey">*</span>
              <input
                v-model="account.first_name"
                type="text"
                @change="inputChanged()"
              >
            </div>

            <!-- Last Name -->
            <div class="tallInput">
              Last Name <span class="colorGrey">*</span>
              <input
                v-model="account.last_name"
                type="text"
                @change="inputChanged()"
              >
            </div>

            <!-- Company (optional) -->
            <div class="tallInput">
              Company <span class="colorGrey" />
              <input
                v-model="account.company"
                type="text"
                placeholder="optional"
                @change="inputChanged()"
              >
            </div>

            <!-- Email -->
            <div class="tallInput">
              Electronic Mail Address <span class="colorGrey">*</span>
              <input
                v-model="account.verify_email"
                type="password"
                class="hidden"
              >
              <div class="hidden">
                Verify Electronic Mail Address <span class="colorGrey">*</span>
              </div>
              <input
                v-model="account.email"
                type="text"
                @change="inputChanged()"
              >
            </div>

            <!-- Password -->
            <div class="tallInput">
              Password <span class="colorGrey">*</span>
              <input
                v-model="account.password"
                type="password"
              >
            </div>

            <!-- Phone -->
            <div class="row">
              <div class="paddingSmallBottom">
                Telephone Number <span class="colorGrey">*</span>
              </div>
              <div class="backgroundColorDimmer borderGrey">
                <VuePhoneNumberInput
                  ref="phoneNumber"
                  v-model="account.phone"
                  :no-validator-state="true"
                  color="#007aff"
                  valid-color="#34c263"
                  error-color="#f44242"
                  :default-country-code="'US'"
                  :border-radius="0"
                  :translations="{ phoneNumberLabel: '' }"
                  :no-example="false"
                />
              </div>
            </div>

            <!-- SMS -->
            <div class="row noPointer marginNormalBottom">
              <div class="paddingSmallBottom paddingNormalTop">
                Text (SMS) Notifications <span class="colorGrey">(US numbers only)</span>
              </div>
              <div class="backgroundColorDimmer borderGrey">
                <VuePhoneNumberInput
                  ref="smsNumber"
                  v-model="account.sms"
                  :no-validator-state="true"
                  color="#007aff"
                  valid-color="#34c263"
                  error-color="#f44242"
                  :default-country-code="'US'"
                  :only-countries="['US']"
                  :border-radius="0"
                  :translations="{ phoneNumberLabel: '', example: 'US Numbers Only:' }"
                />
              </div>
              <div class="paddingSmall">
                <small>*By providing a mobile number, you consent to receiving “selling soon” and “outbid”
                  notifications for lots on which you have placed a bid. You may Opt-Out at any time
                  through your Account page.</small>
              </div>
            </div>
          </div>

          <div class="six columns">
            <!-- Street Address -->
            <div class="tallInput">
              Street Address <span class="colorGrey">*</span>
              <input
                v-model="account.street_address"
                type="text"
                @change="inputChanged()"
              >
            </div>

            <!-- City, State, Zip -->
            <div class="tallInput">
              City <span class="colorGrey">*</span>
              <input
                v-model="account.city"
                type="text"
                @change="inputChanged()"
              >
            </div>
            <div class="tallInput">
              State <span class="colorGrey">*</span>
              <input
                v-model="account.state"
                type="text"
                @change="inputChanged()"
              >
            </div>
            <div class="tallInput">
              Zip <span class="colorGrey">*</span>
              <input
                v-model="account.zip"
                type="text"
                @change="inputChanged()"
              >
            </div>

            <!-- Country drop-down -->
            <div class="tallInput">
              Country <span class="colorGrey">*</span>
              <label for="country" /><select
                id="country"
                v-model="account.country"
              >
                <option value="" />
                <option value="United States">
                  United States
                </option>
                <option value="">
                  ---
                </option>
                <option value="Afghanistan">
                  Afghanistan
                </option>
                <option value="Åland Islands">
                  Åland Islands
                </option>
                <option value="Albania">
                  Albania
                </option>
                <option value="Algeria">
                  Algeria
                </option>
                <option value="American Samoa">
                  American Samoa
                </option>
                <option value="Andorra">
                  Andorra
                </option>
                <option value="Angola">
                  Angola
                </option>
                <option value="Anguilla">
                  Anguilla
                </option>
                <option value="Antarctica">
                  Antarctica
                </option>
                <option value="Antigua and Barbuda">
                  Antigua and Barbuda
                </option>
                <option value="Argentina">
                  Argentina
                </option>
                <option value="Armenia">
                  Armenia
                </option>
                <option value="Aruba">
                  Aruba
                </option>
                <option value="Australia">
                  Australia
                </option>
                <option value="Austria">
                  Austria
                </option>
                <option value="Azerbaijan">
                  Azerbaijan
                </option>
                <option value="Bahamas">
                  Bahamas
                </option>
                <option value="Bahrain">
                  Bahrain
                </option>
                <option value="Bangladesh">
                  Bangladesh
                </option>
                <option value="Barbados">
                  Barbados
                </option>
                <option value="Belarus">
                  Belarus
                </option>
                <option value="Belgium">
                  Belgium
                </option>
                <option value="Belize">
                  Belize
                </option>
                <option value="Benin">
                  Benin
                </option>
                <option value="Bermuda">
                  Bermuda
                </option>
                <option value="Bhutan">
                  Bhutan
                </option>
                <option value="Bolivia">
                  Bolivia
                </option>
                <option value="Bosnia and Herzegovina">
                  Bosnia and Herzegovina
                </option>
                <option value="Botswana">
                  Botswana
                </option>
                <option value="Bouvet Island">
                  Bouvet Island
                </option>
                <option value="Brazil">
                  Brazil
                </option>
                <option value="British Indian Ocean Territory">
                  British Indian Ocean Territory
                </option>
                <option value="Brunei Darussalam">
                  Brunei Darussalam
                </option>
                <option value="Bulgaria">
                  Bulgaria
                </option>
                <option value="Burkina Faso">
                  Burkina Faso
                </option>
                <option value="Burundi">
                  Burundi
                </option>
                <option value="Cambodia">
                  Cambodia
                </option>
                <option value="Cameroon">
                  Cameroon
                </option>
                <option value="Canada">
                  Canada
                </option>
                <option value="Cape Verde">
                  Cape Verde
                </option>
                <option value="Cayman Islands">
                  Cayman Islands
                </option>
                <option value="Central African Republic">
                  Central African Republic
                </option>
                <option value="Chad">
                  Chad
                </option>
                <option value="Chile">
                  Chile
                </option>
                <option value="China">
                  China
                </option>
                <option value="Christmas Island">
                  Christmas Island
                </option>
                <option value="Cocos (Keeling) Islands">
                  Cocos (Keeling) Islands
                </option>
                <option value="Colombia">
                  Colombia
                </option>
                <option value="Comoros">
                  Comoros
                </option>
                <option value="Congo">
                  Congo
                </option>
                <option value="Congo, The Democratic Republic of The">
                  Congo, The Democratic Republic of The
                </option>
                <option value="Cook Islands">
                  Cook Islands
                </option>
                <option value="Costa Rica">
                  Costa Rica
                </option>
                <option value="Cote D'ivoire">
                  Cote D'ivoire
                </option>
                <option value="Croatia">
                  Croatia
                </option>
                <option value="Cuba">
                  Cuba
                </option>
                <option value="Cyprus">
                  Cyprus
                </option>
                <option value="Czech Republic">
                  Czech Republic
                </option>
                <option value="Denmark">
                  Denmark
                </option>
                <option value="Djibouti">
                  Djibouti
                </option>
                <option value="Dominica">
                  Dominica
                </option>
                <option value="Dominican Republic">
                  Dominican Republic
                </option>
                <option value="Ecuador">
                  Ecuador
                </option>
                <option value="Egypt">
                  Egypt
                </option>
                <option value="El Salvador">
                  El Salvador
                </option>
                <option value="Equatorial Guinea">
                  Equatorial Guinea
                </option>
                <option value="Eritrea">
                  Eritrea
                </option>
                <option value="Estonia">
                  Estonia
                </option>
                <option value="Ethiopia">
                  Ethiopia
                </option>
                <option value="Falkland Islands (Malvinas)">
                  Falkland Islands (Malvinas)
                </option>
                <option value="Faroe Islands">
                  Faroe Islands
                </option>
                <option value="Fiji">
                  Fiji
                </option>
                <option value="Finland">
                  Finland
                </option>
                <option value="France">
                  France
                </option>
                <option value="French Guiana">
                  French Guiana
                </option>
                <option value="French Polynesia">
                  French Polynesia
                </option>
                <option value="French Southern Territories">
                  French Southern Territories
                </option>
                <option value="Gabon">
                  Gabon
                </option>
                <option value="Gambia">
                  Gambia
                </option>
                <option value="Georgia">
                  Georgia
                </option>
                <option value="Germany">
                  Germany
                </option>
                <option value="Ghana">
                  Ghana
                </option>
                <option value="Gibraltar">
                  Gibraltar
                </option>
                <option value="Greece">
                  Greece
                </option>
                <option value="Greenland">
                  Greenland
                </option>
                <option value="Grenada">
                  Grenada
                </option>
                <option value="Guadeloupe">
                  Guadeloupe
                </option>
                <option value="Guam">
                  Guam
                </option>
                <option value="Guatemala">
                  Guatemala
                </option>
                <option value="Guernsey">
                  Guernsey
                </option>
                <option value="Guinea">
                  Guinea
                </option>
                <option value="Guinea-bissau">
                  Guinea-bissau
                </option>
                <option value="Guyana">
                  Guyana
                </option>
                <option value="Haiti">
                  Haiti
                </option>
                <option value="Heard Island and Mcdonald Islands">
                  Heard Island and Mcdonald Islands
                </option>
                <option value="Holy See (Vatican City State)">
                  Holy See (Vatican City State)
                </option>
                <option value="Honduras">
                  Honduras
                </option>
                <option value="Hong Kong">
                  Hong Kong
                </option>
                <option value="Hungary">
                  Hungary
                </option>
                <option value="Iceland">
                  Iceland
                </option>
                <option value="India">
                  India
                </option>
                <option value="Indonesia">
                  Indonesia
                </option>
                <option value="Iran, Islamic Republic of">
                  Iran, Islamic Republic of
                </option>
                <option value="Iraq">
                  Iraq
                </option>
                <option value="Ireland">
                  Ireland
                </option>
                <option value="Isle of Man">
                  Isle of Man
                </option>
                <option value="Israel">
                  Israel
                </option>
                <option value="Italy">
                  Italy
                </option>
                <option value="Jamaica">
                  Jamaica
                </option>
                <option value="Japan">
                  Japan
                </option>
                <option value="Jersey">
                  Jersey
                </option>
                <option value="Jordan">
                  Jordan
                </option>
                <option value="Kazakhstan">
                  Kazakhstan
                </option>
                <option value="Kenya">
                  Kenya
                </option>
                <option value="Kiribati">
                  Kiribati
                </option>
                <option value="Korea, Democratic People's Republic of">
                  Korea, Democratic People's Republic
                  of
                </option>
                <option value="Korea, Republic of">
                  Korea, Republic of
                </option>
                <option value="Kuwait">
                  Kuwait
                </option>
                <option value="Kyrgyzstan">
                  Kyrgyzstan
                </option>
                <option value="Lao People's Democratic Republic">
                  Lao People's Democratic Republic
                </option>
                <option value="Latvia">
                  Latvia
                </option>
                <option value="Lebanon">
                  Lebanon
                </option>
                <option value="Lesotho">
                  Lesotho
                </option>
                <option value="Liberia">
                  Liberia
                </option>
                <option value="Libyan Arab Jamahiriya">
                  Libyan Arab Jamahiriya
                </option>
                <option value="Liechtenstein">
                  Liechtenstein
                </option>
                <option value="Lithuania">
                  Lithuania
                </option>
                <option value="Luxembourg">
                  Luxembourg
                </option>
                <option value="Macao">
                  Macao
                </option>
                <option value="Macedonia, The Former Yugoslav Republic of">
                  Macedonia, The Former Yugoslav
                  Republic of
                </option>
                <option value="Madagascar">
                  Madagascar
                </option>
                <option value="Malawi">
                  Malawi
                </option>
                <option value="Malaysia">
                  Malaysia
                </option>
                <option value="Maldives">
                  Maldives
                </option>
                <option value="Mali">
                  Mali
                </option>
                <option value="Malta">
                  Malta
                </option>
                <option value="Marshall Islands">
                  Marshall Islands
                </option>
                <option value="Martinique">
                  Martinique
                </option>
                <option value="Mauritania">
                  Mauritania
                </option>
                <option value="Mauritius">
                  Mauritius
                </option>
                <option value="Mayotte">
                  Mayotte
                </option>
                <option value="Mexico">
                  Mexico
                </option>
                <option value="Micronesia, Federated States of">
                  Micronesia, Federated States of
                </option>
                <option value="Moldova, Republic of">
                  Moldova, Republic of
                </option>
                <option value="Monaco">
                  Monaco
                </option>
                <option value="Mongolia">
                  Mongolia
                </option>
                <option value="Montenegro">
                  Montenegro
                </option>
                <option value="Montserrat">
                  Montserrat
                </option>
                <option value="Morocco">
                  Morocco
                </option>
                <option value="Mozambique">
                  Mozambique
                </option>
                <option value="Myanmar">
                  Myanmar
                </option>
                <option value="Namibia">
                  Namibia
                </option>
                <option value="Nauru">
                  Nauru
                </option>
                <option value="Nepal">
                  Nepal
                </option>
                <option value="Netherlands">
                  Netherlands
                </option>
                <option value="Netherlands Antilles">
                  Netherlands Antilles
                </option>
                <option value="New Caledonia">
                  New Caledonia
                </option>
                <option value="New Zealand">
                  New Zealand
                </option>
                <option value="Nicaragua">
                  Nicaragua
                </option>
                <option value="Niger">
                  Niger
                </option>
                <option value="Nigeria">
                  Nigeria
                </option>
                <option value="Niue">
                  Niue
                </option>
                <option value="Norfolk Island">
                  Norfolk Island
                </option>
                <option value="Northern Mariana Islands">
                  Northern Mariana Islands
                </option>
                <option value="Norway">
                  Norway
                </option>
                <option value="Oman">
                  Oman
                </option>
                <option value="Pakistan">
                  Pakistan
                </option>
                <option value="Palau">
                  Palau
                </option>
                <option value="Palestinian Territory, Occupied">
                  Palestinian Territory, Occupied
                </option>
                <option value="Panama">
                  Panama
                </option>
                <option value="Papua New Guinea">
                  Papua New Guinea
                </option>
                <option value="Paraguay">
                  Paraguay
                </option>
                <option value="Peru">
                  Peru
                </option>
                <option value="Philippines">
                  Philippines
                </option>
                <option value="Pitcairn">
                  Pitcairn
                </option>
                <option value="Poland">
                  Poland
                </option>
                <option value="Portugal">
                  Portugal
                </option>
                <option value="Puerto Rico">
                  Puerto Rico
                </option>
                <option value="Qatar">
                  Qatar
                </option>
                <option value="Reunion">
                  Reunion
                </option>
                <option value="Romania">
                  Romania
                </option>
                <option value="Russian Federation">
                  Russian Federation
                </option>
                <option value="Rwanda">
                  Rwanda
                </option>
                <option value="Saint Helena">
                  Saint Helena
                </option>
                <option value="Saint Kitts and Nevis">
                  Saint Kitts and Nevis
                </option>
                <option value="Saint Lucia">
                  Saint Lucia
                </option>
                <option value="Saint Pierre and Miquelon">
                  Saint Pierre and Miquelon
                </option>
                <option value="Saint Vincent and The Grenadines">
                  Saint Vincent and The Grenadines
                </option>
                <option value="Samoa">
                  Samoa
                </option>
                <option value="San Marino">
                  San Marino
                </option>
                <option value="Sao Tome and Principe">
                  Sao Tome and Principe
                </option>
                <option value="Saudi Arabia">
                  Saudi Arabia
                </option>
                <option value="Senegal">
                  Senegal
                </option>
                <option value="Serbia">
                  Serbia
                </option>
                <option value="Seychelles">
                  Seychelles
                </option>
                <option value="Sierra Leone">
                  Sierra Leone
                </option>
                <option value="Singapore">
                  Singapore
                </option>
                <option value="Slovakia">
                  Slovakia
                </option>
                <option value="Slovenia">
                  Slovenia
                </option>
                <option value="Solomon Islands">
                  Solomon Islands
                </option>
                <option value="Somalia">
                  Somalia
                </option>
                <option value="South Africa">
                  South Africa
                </option>
                <option value="South Georgia and The South Sandwich Islands">
                  South Georgia and The South
                  Sandwich Islands
                </option>
                <option value="Spain">
                  Spain
                </option>
                <option value="Sri Lanka">
                  Sri Lanka
                </option>
                <option value="Sudan">
                  Sudan
                </option>
                <option value="Suriname">
                  Suriname
                </option>
                <option value="Svalbard and Jan Mayen">
                  Svalbard and Jan Mayen
                </option>
                <option value="Swaziland">
                  Swaziland
                </option>
                <option value="Sweden">
                  Sweden
                </option>
                <option value="Switzerland">
                  Switzerland
                </option>
                <option value="Syrian Arab Republic">
                  Syrian Arab Republic
                </option>
                <option value="Taiwan, Province of China">
                  Taiwan, Province of China
                </option>
                <option value="Tajikistan">
                  Tajikistan
                </option>
                <option value="Tanzania, United Republic of">
                  Tanzania, United Republic of
                </option>
                <option value="Thailand">
                  Thailand
                </option>
                <option value="Timor-leste">
                  Timor-leste
                </option>
                <option value="Togo">
                  Togo
                </option>
                <option value="Tokelau">
                  Tokelau
                </option>
                <option value="Tonga">
                  Tonga
                </option>
                <option value="Trinidad and Tobago">
                  Trinidad and Tobago
                </option>
                <option value="Tunisia">
                  Tunisia
                </option>
                <option value="Turkey">
                  Turkey
                </option>
                <option value="Turkmenistan">
                  Turkmenistan
                </option>
                <option value="Turks and Caicos Islands">
                  Turks and Caicos Islands
                </option>
                <option value="Tuvalu">
                  Tuvalu
                </option>
                <option value="Uganda">
                  Uganda
                </option>
                <option value="Ukraine">
                  Ukraine
                </option>
                <option value="United Arab Emirates">
                  United Arab Emirates
                </option>
                <option value="United Kingdom">
                  United Kingdom
                </option>
                <option value="United States">
                  United States
                </option>
                <option value="United States Minor Outlying Islands">
                  United States Minor Outlying Islands
                </option>
                <option value="Uruguay">
                  Uruguay
                </option>
                <option value="Uzbekistan">
                  Uzbekistan
                </option>
                <option value="Vanuatu">
                  Vanuatu
                </option>
                <option value="Venezuela">
                  Venezuela
                </option>
                <option value="Viet Nam">
                  Viet Nam
                </option>
                <option value="Virgin Islands, British">
                  Virgin Islands, British
                </option>
                <option value="Virgin Islands, U.S.">
                  Virgin Islands, U.S.
                </option>
                <option value="Wallis and Futuna">
                  Wallis and Futuna
                </option>
                <option value="Western Sahara">
                  Western Sahara
                </option>
                <option value="Yemen">
                  Yemen
                </option>
                <option value="Zambia">
                  Zambia
                </option>
                <option value="Zimbabwe">
                  Zimbabwe
                </option>
              </select>
            </div>

            <div class="tallInput">
              Tax exempt?
              <label for="tax-exempt" />
              <select
                id="tax-exempt"
                v-model="account.tax_exempt"
              >
                <option
                  value="n"
                  selected="selected"
                >
                  No
                </option>
                <option value="y">
                  Yes
                </option>
              </select>
            </div>

            <div class="tallInput">
              <div class="transparent">
                Text (SMS) Notifications (US numbers only)
              </div>

              <button
                v-if="typeof (apiPending.create_account) !== 'undefined'"
                class="disabledButton bidButton u-full-width"
                disabled="disabled"
              >
                <div class="loading" />
              </button>
              <button
                v-else
                id="create_account_button"
                type="submit"
                class="bidButton backgroundColorDefault u-full-width button-label"
                @click="createAccount('create_account')"
              >
                Create Account
              </button>
              <small>*By creating an account, you agree to our <a href="/terms.html">Terms of Use</a> and <a href="/privacy.html">Privacy Policy</a>.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row marginLargeBottom">
      <div class="twelve columns">
        <div class="paddingLargeTop">
          <a
            class="navLink"
            @click="onClose"
          >
            <span v-if="!successfullyCreatedAccount">Cancel</span>
            <span v-else>Close</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiResponse from '@/components/ApiResponse.vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
    name: 'CreateAccount',
    components: {
        ApiResponse,
        VuePhoneNumberInput
    },
    props: ['onClose'],
    data() {
        return {
            account: {
                first_name: '',
                last_name: '',
                email: '',
                verify_email: '',
                password: '',
                phone: '',
                sms: '',
                street_address: '',
                city: '',
                state: '',
                zip: '',
                country: '',
                tax_exempt: 'n'
            },
            showError: false
        }
    },
    computed: {
        successfullyCreatedAccount: function () {
            return this.$store.getters.successfullyCreatedAccount
        },
        apiPending: function () {
            return this.$store.getters.apiPending
        },
    },
    mounted() {
    },
    methods: {
        inputChanged() {
            if (this.showError) {
                this.showError = false
            }
        },
        createAccount(context) {
            let payload = this.account
            let verificationError = false

            if (!this.checkForValidCharacters(payload.first_name)) {
                this.account.first_name = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.last_name)) {
                this.account.last_name = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.email)) {
                this.account.email = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.company)) {
                this.account.company = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.street_address)) {
                this.account.street_address = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.city)) {
                this.account.city = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.state)) {
                this.account.state = ''
                verificationError = true
            }

            if (!this.checkForValidCharacters(payload.zip)) {
                this.account.zip = ''
                verificationError = true
            }

            if (verificationError === false) {
                this.showError = false
                payload.context = context
                this.$store.dispatch('createAccount', payload)
            } else {
                this.showError = true
            }
        },
        showSignIn() {
            this.$store.dispatch('showModal', { component: 'Signin' })
        },
        checkForValidCharacters(value) {
            const regex = /^[a-zA-Z0-9\s@&$#!%^*()_+=[\]{};:'"\\|,.<>/?]*$/; // only allow english letters, numbers, and special characters
            if (regex.test(value)) {
                return true;
            }

            return false;
        }
    }
}

</script>

<style scoped>
.button-label {
    line-height: 4.5rem;
}
</style>
